var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-call-3993397 1",
    clipPath: "url(#clip0_3252_17045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2052 12.0748L20.8978 14.6689C22.3625 15.4782 20.7406 17.3146 19.425 18.3464C13.6122 22.9036 -1.35383 8.00443 3.26068 2.18203C4.29916 0.871524 6.12889 -0.755437 6.93817 0.709215L9.53223 5.4019C9.77116 5.83421 9.61553 6.29559 9.31767 6.68909L8.38311 7.92406C8.10387 8.29332 8.08633 8.7737 8.33704 9.16263C9.45146 10.8884 10.7186 12.1554 12.4445 13.2701C12.8334 13.5209 13.3138 13.5034 13.683 13.224L14.918 12.2894C15.3116 11.9916 15.7729 11.8359 16.2052 12.0749L16.2052 12.0748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5941 8.97541C20.5966 9.25519 20.8253 9.48071 21.1056 9.47803C21.3859 9.47603 21.6109 9.24687 21.6087 8.96656C21.5632 4.07947 17.5294 0.0461016 12.6423 0.000501638C12.3626 -0.0015073 12.1334 0.223359 12.1309 0.503679C12.1289 0.783457 12.3537 1.01262 12.634 1.01515C16.9654 1.05493 20.5537 4.64361 20.5942 8.97527L20.5941 8.97541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.1411 8.95247C18.1436 9.23225 18.3728 9.45777 18.6526 9.4551C18.9329 9.45309 19.1579 9.22394 19.1557 8.94362C19.1232 5.40534 16.2043 2.48694 12.6658 2.45437C12.386 2.45182 12.1568 2.67722 12.1543 2.957C12.1523 3.23731 12.3772 3.46645 12.6575 3.46847C15.6399 3.49646 18.1134 5.96944 18.1408 8.95247H18.1411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6863 8.92972C15.6883 9.2095 15.9175 9.43502 16.1978 9.43235C16.4776 9.43034 16.7031 9.20118 16.7004 8.92087C16.6802 6.73128 14.877 4.9283 12.6873 4.90773C12.4075 4.90572 12.1783 5.13059 12.1758 5.41091C12.1738 5.69122 12.3987 5.91984 12.679 5.92238C14.3126 5.93738 15.6707 7.29542 15.6862 8.92961L15.6863 8.92972Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3252_17045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.7229,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCall);
export default __webpack_public_path__ + "static/media/icon-call.54d4c5d8a1be304eff5fdfa62da5d68a.svg";
export { ForwardRef as ReactComponent };